interface Props {
  children: React.ReactNode
  className?: string
  colSpan?: number
}

const HeaderCell = ({ children, className = "", colSpan }: Props) => (
  <th
    {...(colSpan ? { colSpan } : {})}
    className={`px-2 md:px-4 py-1 md:py-2 ${className}`}
  >
    {children}
  </th>
)

export default HeaderCell
